<template>
    <button v-on:click="generateDocument" class="rounded-xl px-8 h-[35px] border font-light bg-black text-white flex items-center gap-x-2">
        <Send :size="16" strokeWidth="1.2"/> Envoyer par mail
        <div :v-html="stringHtml" id="template" class="hidden"></div>
    </button>
</template>
<script>
// import { ficheDePaieTemplate } from '../../service/fiche-de-paie-template';
// import { jsPDF } from "jspdf";
import {Send} from "lucide-vue-next"
export default {
    name: "LoadDocument",
    props: ["data"],
    components:{
        Send
    },
    data(){
        return {
            stringHtml: ""
        }
    },
    mounted(){
        // this.stringHtml = ficheDePaieTemplate(this.data);
    },
    methods: {
        generateDocument(){
            // const template = document.querySelector("#template");
            // const options = {
            //     margin: 10,
            //     filename: this.data.nom_prenom.trim()+'_bulletin'+'.pdf',
            //     image: { type: 'jpeg', quality: 0.98 },
            //     html2canvas: { scale: 2 },
            //     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            // };
            // html2pdf().set(options).from(template).save();
            // const doc = new jsPDF({
            //     orientation: "landscape",
            //     unit: "in",
            //     format: [4, 2]
            // });
        }
    }
}
</script>